import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=4ced6a15&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/simplePage.css?vue&type=style&index=0&id=4ced6a15&prod&scoped=true&lang=css&"
import style1 from "./RegisterForm.vue?vue&type=style&index=1&id=4ced6a15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced6a15",
  null
  
)

export default component.exports